﻿import { FC, ReactNode } from "react";
import { Box, Flex, FlexProps, Heading } from "@chakra-ui/react";
import { ApplicationLayoutBoxShadow } from "../../theme";

export type TopNavProps = {
    title?: string | null | undefined;
    subTitle?: string | null | undefined;
    menu?: ReactNode | null | undefined;
} & FlexProps;

export const TopNav: FC<TopNavProps> = ({ title, subTitle, menu, ...flexProps }) => {
    return (
        <Flex justifyContent={"space-between"} p={"1rem 3rem"} gap={"1rem"} boxShadow={ApplicationLayoutBoxShadow} {...flexProps}>
            <Flex direction={"column"} gap={".5rem"}>
                {title && (
                    <Heading size={"xl"} variant={"page"} whiteSpace={"nowrap"} paddingRight={"2rem"}>
                        {title}
                    </Heading>
                )}
                {subTitle && <Heading variant={"info"}>{subTitle}</Heading>}
            </Flex>
            {!!menu && <Box>{menu}</Box>}
        </Flex>
    );
};
